<template>
    <div>
        <transition name="fade" mode="out-in">
            <ContactForm v-if="formVisible"
                         :submit-text="$t('generic.submit')"
                         :is-sending="isSendingData"
                         @submit="sendContactForm">
                <template v-slot:before>
                    <h1 class="card-title h5">{{ $t('noBookingService.title.reservation_failed.text') }}</h1>
                    <p class="card-text">
                        {{ $t('noBookingService.supporting_text.reservation_failed.text') }}
                    </p>
                </template>

                <template v-slot:action>
                    <button class="btn btn-outline-secondary" type="button" @click="$store.dispatch('reset')">
                        {{ $t('generic.back') }}
                    </button>
                </template>
            </ContactForm>

            <!-- Success message after form submission -->
            <div v-else>
                <h1 class="card-title h5">{{ $t('noBookingService.title.reservation_successfull.title') }}</h1>
                <p class="card-text">
                    {{ $t('noBookingService.supporting_text.reservation_successfull.text') }}
                </p>
                <CustomerServiceBlock/>
                <div class="card-navigation">
                    <button class="btn btn-secondary" type="button" @click="$store.dispatch('reset')">
                        {{ $t('common.redeem_another_voucher') }}
                    </button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import GdprNotice from '../components/GdprNotice';
    import CustomerServiceBlock from "./CustomerServiceBlock";
    import ContactForm from '@/components/ContactForm';
    import { mapState, mapGetters } from 'vuex';

    export default {
        name: 'NoBookingServiceForm',
        components: {
            CustomerServiceBlock,
            GdprNotice,
            ContactForm
        },
        data () {
            return {
                errors: [],
                formVisible: true,
                isSendingData: false
            }
        },
        computed: {
            ...mapState([ 'voucher', 'activationData' ]),
            ...mapGetters(['voucherCode'])
        },
        methods: {
            async sendContactForm(contactData) {
                this.isSendingData = true;
                try {
                    const response = await this.$store.dispatch('sendContactForm', {
                        ...contactData,
                        voucherCode: this.voucherCode,
                    });
                    this.formVisible = false;
                }
                finally {
                    this.isSendingData = false;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @media screen and (max-width: 767px) {
        body:not(.popup) {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
    }
</style>
